function normaliseSlug(value: string): string {
  return value.trim().toLowerCase()
}

export function normaliseLocationSlugForLookup(value: string): string {
  // Use a stable, URL-like key for slug lookup (lowercase, '+' for spaces).
  return value.trim().toLowerCase().replace(/-/g, '+')
}

export function plusSlugFromText(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '+')
    .replace(/\++/g, '+')
}

export function slugFromText(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/(^-|-$)/g, '')
}

export function resolveCategoryCodesFromSlug(params: {
  categorySlug?: string
  categories: Array<App.ExperienceItemCategory>
}): Array<number> | undefined {
  const { categorySlug, categories } = params
  if (!categorySlug) return undefined

  const slug = normaliseSlug(categorySlug)
  const matched = categories.find((cat) => (
    plusSlugFromText(cat.name) === slug ||
    slugFromText(cat.name) === slug
  ))
  if (!matched) return undefined

  if (matched.level === 'parent') {
    const childIds = categories
      .filter((cat) => cat.parentId === matched.id)
      .map((cat) => cat.id)
    return childIds.length ? childIds : [matched.id]
  }

  return [matched.id]
}
